import { render, staticRenderFns } from "./DlgTopicNotification.vue?vue&type=template&id=aa4e9bce&scoped=true&"
import script from "./DlgTopicNotification.vue?vue&type=script&lang=ts&"
export * from "./DlgTopicNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa4e9bce",
  null
  
)

export default component.exports